import React, { useEffect, useState } from 'react';
import { bool, func, shape, string } from 'prop-types';
import classNames from 'classnames';
import { Form as FinalForm } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import { compose } from 'redux';
import { intlShape, injectIntl, FormattedMessage } from '../../util/reactIntl';
import { findOptionsForSelectFilter } from '../../util/search';
import { propTypes } from '../../util/types';
import config from '../../config';
import { Button, FieldCheckboxGroup, Form, FieldTextInput, FieldTextInputLong } from '../../components';
import { required, composeValidators } from '../../util/validators';

import css from './EditListingOffersForm.css';
import { Prompt } from 'react-router';

const EditListingOffersFormComponent = props => {
  const [content, setContent] = useState(0);
  const [youtubeRegexValidty, setYoutubeRegexValidty] = useState(true);
  const [linkTouched,setLinkTouched] = useState(false);
  const [youtubeLinkInput, setYoutubeLinkInput] = useState('');
  const char500Limit = 500
  const getValue = value => {
    if (value !== content) {
      setContent(value);
    }
  };

  const handleFormChange = (e) => {
       if(e.target.id =="youtubeLink"){
        setYoutubeLinkInput(e.target.value);
        let youtubeRegex = /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube(-nocookie)?\.com|youtu.be))(\/(?:[\w\-]+\?v=|embed\/|v\/)?)([\w\-]+)(\S+)?$/ ;
        setYoutubeRegexValidty(youtubeRegex.test(e.target.value));
       }
  }

  return(
  <FinalForm
    {...props}
    mutators={{ ...arrayMutators }}
    render={formRenderProps => {
      const {
        disabled,
        ready,
        rootClassName,
        className,
        name,
        youtubeLink,
        surroundingsName,
        handleSubmit,
        pristine,
        saveActionMsg,
        updated,
        updateInProgress,
        fetchErrors,
        filterConfig,
        intl,
      } = formRenderProps;

       if(youtubeLinkInput == '' && !linkTouched){
         setYoutubeLinkInput(youtubeLink);
         setLinkTouched(true);
       }

      const classes = classNames(rootClassName || css.root, className);
      const submitReady = (updated && pristine) || ready;
      const submitInProgress = updateInProgress;
      const submitDisabled = disabled || submitInProgress || (youtubeLinkInput.length > 0 && !youtubeRegexValidty);

      const { updateListingError, showListingsError } = fetchErrors || {};
      const errorMessage = updateListingError ? (
        <p className={css.error}>
          <FormattedMessage id="EditListingOffersForm.updateFailed" />
        </p>
      ) : null;

      const errorMessageShowListing = showListingsError ? (
        <p className={css.error}>
          <FormattedMessage id="EditListingOffersForm.showListingFailed" />
        </p>
      ) : null;

      const activitiesLabelMessage = intl.formatMessage({
        id: 'EditListingOffersForm.activitiesLabel',
      });
      const activitiesPlaceholderMessage = intl.formatMessage({
        id: 'EditListingOffersForm.activitiesPlaceholder',
      });

      const activitiesTip = intl.formatMessage({
        id: 'EditListingOffersForm.activitiesTip',
      });

      const activitiesRequiredMessage = intl.formatMessage({
        id: 'EditListingOffersForm.activitiesRequired',
      });

      const tipVGNtext = intl.formatMessage({
        id: 'EditListingOffersForm.vegan'
      });
      const tipVGTtext = intl.formatMessage({
        id: 'EditListingOffersForm.vegetarian'
      });

      const options = findOptionsForSelectFilter('food', filterConfig);

      const surroundingOptions = findOptionsForSelectFilter('surroundings', filterConfig);
      const youtubeLabel = intl.formatMessage({ id: 'StripePaymentAddress.youtubeLabel' });
      const youtubePlaceHolder = intl.formatMessage({ id: 'StripePaymentAddress.youtubePlaceHolder' });
      const invalidYoutubeLink =  <p className={css.error}>
      <FormattedMessage id="EditListingPhotosForm.invalidYoutubeLink" />
    </p>
      return (
        <Form className={classes} onSubmit={handleSubmit} onChange={handleFormChange} >
          <Prompt
            when={!pristine}
            message="You have unsaved changes, are you sure you want to leave?"
          />
          {errorMessage}
          {errorMessageShowListing}

          <div className={css.sectionTitle}>
            <FormattedMessage id="EditListingOffersForm.foodTitle" />
          </div>
          <div className={css.tip}>
            <p>
              <FormattedMessage id="EditListingOffersForm.foodTip" />
            </p>
          </div>
          <FieldCheckboxGroup className={css.offers} id={name} name={name} options={options} tipVGN={tipVGNtext} tipVGT={tipVGTtext}/>

          <br />
          <div className={css.sectionTitle}>
            <FormattedMessage id="EditListingOffersForm.surroundingsTitle" />
          </div>
          <div className={css.tip}>
            <p>
              <FormattedMessage id="EditListingOffersForm.surroundingsTip" />
            </p>
          </div>
          <FieldCheckboxGroup
            className={css.offers}
            id={surroundingsName}
            name={surroundingsName}
            options={surroundingOptions}
          />
          <br />
          <div className={css.sectionTitle}>
            <FormattedMessage id="EditListingOffersForm.activitiesLabel" />
          </div>

          <div className={css.tip}>
            <FormattedMessage id="EditListingOffersForm.activitiesPlaceholder" />
          </div>

          <div style={{ position: 'relative' }}>
              <p style={{ position: 'absolute', right: '15px', bottom: '0' }}>
                {char500Limit - content.length}
              </p>
          <FieldTextInputLong
            id="activities"
            name="activities"
            className={css.activities}
            type="textarea"
            // label={activitiesLabelMessage}
            placeholder={activitiesTip}
            getValue={getValue.bind(this)}
            validate={composeValidators(required(activitiesRequiredMessage))}
          />
          </div>

          <FieldTextInputLong
            style={{ display: 'none' }}
            type="textarea"
            id="activities_de"
            name="activities_de"
            initialValue={'Übersetzung hinzufügen'}
          />
          {/* <div className={css.tip}>
            <p>
              <FormattedMessage id="EditListingOffersForm.activitiesTip" />
            </p>
          </div> */}
          <br/>
          <br/>
          <label className={css.sectionTitle}>{youtubeLabel}</label>
          <div className={css.tip}>
            <FormattedMessage id="StripePaymentAddress.youtubeSubLabel" />
          </div>
          <br/>
          <FieldTextInput
            id="youtubeLink"
            name="youtubeLink"
            disabled={false}
            className={css.field}
            type="text"
            placeholder={youtubePlaceHolder}
            style={{ float: 'left' }}
          />
          {(youtubeLinkInput.length > 0 && !youtubeRegexValidty) ?  invalidYoutubeLink: null}

          <Button
            className={css.submitButton}
            type="submit"
            inProgress={submitInProgress}
            disabled={submitDisabled}
            ready={submitReady}
          >
            {saveActionMsg}
          </Button>
        </Form>
      );
    }}
  />
);
}
EditListingOffersFormComponent.defaultProps = {
  rootClassName: null,
  className: null,
  fetchErrors: null,
  filterConfig: config.custom.filters,
};

EditListingOffersFormComponent.propTypes = {
  rootClassName: string,
  className: string,
  name: string.isRequired,
  youtubeLink: string,
  onSubmit: func.isRequired,
  saveActionMsg: string.isRequired,
  disabled: bool.isRequired,
  ready: bool.isRequired,
  updated: bool.isRequired,
  updateInProgress: bool.isRequired,
  fetchErrors: shape({
    showListingsError: propTypes.error,
    updateListingError: propTypes.error,
  }),
  filterConfig: propTypes.filterConfig,
  intl: intlShape.isRequired,
};

const EditListingOffersForm = EditListingOffersFormComponent;

export default compose(injectIntl)(EditListingOffersForm);
